// project imports
import { Routes } from 'utils/constants';

// assets
import { IconCloudDataConnection } from '@tabler/icons';

// types
import { NavItemType } from 'models';
import { MenuItemsCA } from 'routes/menu-items/index';

export const ONLINE_DISPATCHING_MENU_ID = 'online-dispatching';
export const PRODUCTION_PLANNING_MENU_ID = 'production-planning';
export const CONSUMPTION_PLANNING_MENU_ID = 'consumption-planning';
export const OPERATION_CALENDAR_MENU_ID = 'operation-calendar';
export const H_X_DASHBOARD_MENU_ID = 'h-plus-x-si';
export const RK_DASHBOARD_MENU_ID = 'rk-dashboard';

// ==============================|| DISPATCHER MENU ITEMS ||============================== //

const DispatcherOnlineDispatchingMenu = (
  canAccessOnlineDispatchingPage: boolean
) => {
  return canAccessOnlineDispatchingPage
    ? {
        id: ONLINE_DISPATCHING_MENU_ID,
        title: 'navigation.dispatcher.onlineDispatching',
        type: 'item',
        url: Routes.DISPATCHER.ONLINE_DISPATCHING_BALANCING_GROUP_ID_PATH,
        children: [
          {
            id: 'online-dispatching-deliveryPoint',
            title: 'navigation.dispatcher.onlineDispatchingDeliveryPoint',
            type: 'item',
            url: Routes.DISPATCHER.ONLINE_DISPATCHING_DELIVERY_POINT_PATH,
            children: [
              {
                id: 'online-dispatching-device',
                title: 'navigation.dispatcher.onlineDispatchingDevice',
                type: 'item',
                url: Routes.DISPATCHER.ONLINE_DISPATCHING_DEVICE_PATH
              }
            ]
          }
        ]
      }
    : {};
};

const DispatcherProductionPlanMenu = (canAccessProductionPlanPage: boolean) => {
  return canAccessProductionPlanPage
    ? {
        id: PRODUCTION_PLANNING_MENU_ID,
        title: 'navigation.dispatcher.productionPlanning',
        type: 'item',
        url: Routes.DISPATCHER.PRODUCTION_PLANNING_PATH
      }
    : {};
};

const DispatcherConsumptionPlanningMenu = (
  canAccessConsumptionPage: boolean
) => {
  return canAccessConsumptionPage
    ? {
        id: CONSUMPTION_PLANNING_MENU_ID,
        title: 'navigation.dispatcher.consumptionPlanning',
        type: 'item',
        url: Routes.DISPATCHER.CONSUMPTION_PLANNING_PATH
      }
    : {};
};

const DispatcherOperationCalendarMenu = (
  canAccessOperationCalendarPage: boolean
) => {
  return canAccessOperationCalendarPage
    ? {
        id: OPERATION_CALENDAR_MENU_ID,
        title: 'navigation.dispatcher.operationCalendar',
        type: 'item',
        url: Routes.DISPATCHER.OPERATION_CALENDAR_PATH
      }
    : {};
};

const DispatcherHxDashboardMenu = (canAccessHxDashboardPage: boolean) => {
  return canAccessHxDashboardPage
    ? {
        id: H_X_DASHBOARD_MENU_ID,
        title: 'navigation.dispatcher.hxDashboard',
        type: 'item',
        url: Routes.DISPATCHER.HX_DASHBOARD
      }
    : {};
};

const DispatcherRkDashboardMenu = (canAccessRkDashboardPage: boolean) => {
  return canAccessRkDashboardPage
    ? {
        id: RK_DASHBOARD_MENU_ID,
        title: 'navigation.dispatcher.rkDashboard',
        type: 'item',
        url: Routes.DISPATCHER.RK_DASHBOARD
      }
    : {};
};

const dispatcher = (menuItemsCA: MenuItemsCA): NavItemType => {
  return {
    id: 'dispatcher',
    title: '',
    type: 'group',
    children: [
      {
        id: 'dispatcher-group',
        title: 'navigation.dispatcher.group',
        type: 'collapse',
        icon: IconCloudDataConnection,
        children: [
          DispatcherOnlineDispatchingMenu(
            menuItemsCA.canAccessOnlineDispatchingPage
          ),
          DispatcherProductionPlanMenu(menuItemsCA.canAccessProductionPlanPage),
          DispatcherConsumptionPlanningMenu(
            menuItemsCA.canAccessConsumptionPlanPage
          ),
          DispatcherOperationCalendarMenu(
            menuItemsCA.canAccessOperationCalendarPage
          ),
          DispatcherHxDashboardMenu(menuItemsCA.canAccessHxDashboardPage),
          DispatcherRkDashboardMenu(menuItemsCA.canAccessRkDashboardPage)
        ]
      }
    ]
  };
};

export default dispatcher;
